import React from 'react'


const FlightInfo = (props) => {
            
    let {selectedFlightInfo} = props
    // let testData = {
    //     comments: {
    //         opscomments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vulputate quis tortor ac luctus. Vestibulum quis eros eros. Maecenas ipsum urna, posuere ut fermentum auctor, egestas at ante. Nulla facilisi. Fusce at finibus erat, sit amet placerat ante. Cras placerat purus at odio pulvinar aliquam. Duis eleifend ante non vulputate interdum. Morbi a nisl nisi. Phasellus tincidunt elit velit, non laoreet neque vulputate vel. Pellentesque eros sapien, egestas quis blandit et, venenatis pharetra ligula. Fusce molestie nulla quis metus malesuada, non pharetra sem elementum.',
    //     },
       
    // }

    return  (
        <div>
            <h3>Flight Ops Comments:</h3>
            <p>{selectedFlightInfo.flightOpsComments}</p>
        </div>
    )
}

export default FlightInfo